import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../config'
import {
  Alert,
  LayoutAnimation,
  TouchableOpacity,
  Dimensions,
  Image,
  UIManager,
  KeyboardAvoidingView,
  StyleSheet,
  ScrollView,
  Text,
  View
} from 'react-native';
import { Input, Button, Icon } from 'react-native-elements';
import { LinearGradient } from '../../components/LinearGradient';
import UserPersistence from '../../singletons/UserPersistence';
import * as Font from 'expo-font';
import { isLoaded} from 'expo-font';
// Enable LayoutAnimation on Android
UIManager.setLayoutAnimationEnabledExperimental &&
  UIManager.setLayoutAnimationEnabledExperimental(true);

const USER_COOL = require('../../../assets/images/user-cool.png');
const USER_STUDENT = require('../../../assets/images/user-student.png');
const USER_HP = require('../../../assets/images/user-hp.png');

const SCREEN_WIDTH = Dimensions.get('window').width;
const SCREEN_HEIGHT = Dimensions.get('window').height;

export default class LoginScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      selectedType: null,
      username: '',
      email: '',
      password: '',
      confirmationPassword: '',
      emailValid: true,
      passwordValid: true,
      usernameValid: true,
      confirmationPasswordValid: true,
      isReady: false
    };

    this.setSelectedType = this.setSelectedType.bind(this);
    
    this.validatePassword = this.validatePassword.bind(this);
    this.login = this.login.bind(this);

  }


  login() {
    LayoutAnimation.easeInEaseOut();
    const usernameValid = this.validateUsername();
    const passwordValid = this.validatePassword();
    if (
      passwordValid &&
      usernameValid
    ) {
      this.setState({ isLoading: true });
      setTimeout(() => {
        LayoutAnimation.easeInEaseOut();
        this.setState({ isLoading: false });
        Alert.alert('🎸', 'Login failed');
      }, 1500);
      var loginParams =  {
        'userName':this.state.username,
        'password': this.state.password
      };
      axios.post(config.user.protocol + config.user.address + ':' + config.user.port + '/WebSite/Login', {},
      {
        params: {data:JSON.stringify(loginParams)}
      },
      {
        headers: { 
          "Content-Type":   "application/json",
          "X-Auth-User":    UserPersistence.getInstance().userId,
          "X-Auth-Token":   UserPersistence.getInstance().userAccessToken,
          "access-control-allow-origin" : "*",
        }
      })
      .then(async res => {
        
        if (this.isResponseOk(res)) {
          
            this.setState({ isLoading: false });
            UserPersistence.getInstance().userId = res.data.userId.trim();
            UserPersistence.getInstance().userAccessToken = res.data.accessToken.trim();
            UserPersistence.getInstance().userName = res.data.company.trim();
          
            await this.getUserClass(UserPersistence.getInstance().userName);
            this.props.navigation.navigate('Home');
            console.log("Login res");

        } else {
          alert('Login Failed');
          this.setState({ isLoading: false });

          //this.setState({chatFrequency: 1200, autoChatState: true})
        }
        // starting websocket
        //this.onStartSocket();
      });
    }
  }

    async getUserClass(userName) {
        try {
          const response = await axios({
            method: "get",
            url: config.user.protocol + config.user.address + ':' + config.user.port + '/GetUserClass'+ "?userName="+ userName,
            timeout: 1000 * 60,
            headers: { 
              "Content-Type":   "application/json",
              "X-Auth-User":    UserPersistence.getInstance().userId,
              "X-Auth-Token":   UserPersistence.getInstance().userAccessToken
            },
            data: {} 
          });
      
          if (this.isResponseOk(response)) {
            UserPersistence.getInstance().userClass = response.data.trim();
          } else {
            alert("Fail to get user class");
          }
        } catch (error) {
          console.error("Error in getUserClass:", error);
          alert("An error occurred while fetching user class");
        }
    }
  isResponseOk(res) {
    if ( res != null && res.status == 200 && res.data != null) {
      return true;
    } else {
      return false;
    }
  }
  validateUsername() {
    const { username } = this.state;
    const usernameValid = username.length > 0;
    LayoutAnimation.easeInEaseOut();
    this.setState({ usernameValid });
    usernameValid || this.usernameInput.shake();
    return usernameValid;
  }

 

  validatePassword() {
    const { password } = this.state;
    const passwordValid = password.length >= 3;
    LayoutAnimation.easeInEaseOut();
    this.setState({ passwordValid });
    passwordValid || this.passwordInput.shake();
    return passwordValid;
  }



  setSelectedType = selectedType =>
    LayoutAnimation.easeInEaseOut() || this.setState({ selectedType });

  render() {
    const {
      isLoading,
      password,
      passwordValid,
      username,
      usernameValid,
      isReady
    } = this.state;

    return (
      <ScrollView
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={styles.container}
      >
        <KeyboardAvoidingView
          behavior="position"
          contentContainerStyle={styles.formContainer}
        >
          <Text style={styles.loginText}>Please Login</Text>
          
          <View style={{ width: '100%', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
            <FormInput
              refInput={input => (this.usernameInput = input)}
              icon="user"
              value={username}
              onChangeText={username => this.setState({ username })}
              placeholder="Username"
              returnKeyType="next"
              errorMessage={
                usernameValid ? null : "Your username can't be blank"
              }
              onSubmitEditing={() => {
                this.validateUsername();
                this.emailInput.focus();
              }}
            />
     
            <FormInput
              refInput={input => (this.passwordInput = input)}
              icon="lock"
              value={password}
              onChangeText={password => this.setState({ password })}
              placeholder="Password"
              secureTextEntry
              returnKeyType="next"
              errorMessage={
                passwordValid ? null : 'Please enter at least 3 characters'
              }
              onSubmitEditing={() => {
                this.validatePassword();
              }}
            />
           
          </View>
          <View style={{ width: '100%', alignItems: 'center' }}>
            <Button
              loading={isLoading}
              title="LOGIN"
              containerStyle={{ flex: -1 }}
              buttonStyle={styles.loginButton}
              linearGradientProps={{
                colors: ['#FF9800', '#F44336'],
                start: [1, 0],
                end: [0.2, 0],
              }}
              ViewComponent={LinearGradient}
              titleStyle={styles.loginButtonText}
              onPress= {() => this.login()}
              disabled={isLoading}
            />
            
          </View>
        </KeyboardAvoidingView>
        
      </ScrollView>
    );
  }
}

export const UserTypeItem = props => {
  const { image, label, labelColor, selected, ...attributes } = props;
  return (
    <TouchableOpacity {...attributes}>
      <View
        style={[
          styles.userTypeItemContainer,
          selected && styles.userTypeItemContainerSelected,
        ]}
      >
        <Text style={[styles.userTypeLabel, { color: labelColor }]}>
          {label}
        </Text>
        <Image
          source={image}
          style={[
            styles.userTypeMugshot,
            selected && styles.userTypeMugshotSelected,
          ]}
        />
      </View>
    </TouchableOpacity>
  );
};

export const FormInput = props => {
  const { icon, refInput, ...otherProps } = props;
  return (
    <Input
      {...otherProps}
      ref={refInput}
      inputContainerStyle={styles.inputContainer}
      leftIcon={
        <Icon name={icon}  type={'simple-line-icon'} color="#7384B4" size={18} />
      }
      inputStyle={styles.inputStyle}
      autoFocus={false}
      autoCapitalize="none"
      keyboardAppearance="dark"
      errorStyle={styles.errorInputStyle}
      autoCorrect={false}
      blurOnSubmit={false}
      placeholderTextColor="#7384B4"
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    paddingBottom: 20,
    paddingTop: 20,
    backgroundColor: '#356AA0',
    width: SCREEN_WIDTH,
    height: SCREEN_HEIGHT,
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  formContainer: {
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  loginText: {
    color: 'white',
    fontSize: 28,
    fontFamily: 'UbuntuLight',
    textAlign: 'center',
  },

  inputContainer: {
    paddingLeft: 8,
    borderRadius: 40,
    borderWidth: 1,
    borderColor: 'rgba(110, 120, 170, 1)',
    height: 45,
    marginVertical: 10,
  },
  inputStyle: {
    flex: 1,
    marginLeft: 10,
    color: 'white',
    fontFamily: 'UbuntuLight',
    fontSize: 16,
  },
  errorInputStyle: {
    marginTop: 0,
    textAlign: 'center',
    color: '#F44336',
  },
  loginButtonText: {
    fontFamily: 'UbuntuBold',
    fontSize: 13,
  },
  loginButton: {
    width: 250,
    borderRadius: Math.round(45 / 2),
    height: 45,
  },
  loginHereContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  alreadyAccountText: {
    fontFamily: 'UbuntuLightItalic',
    fontSize: 12,
    color: 'white',
  },
  loginHereText: {
    color: '#FF9800',
    fontFamily: 'UbuntuLightItalic',
    fontSize: 12,
  },
});
